import { useQuery } from 'react-query';
import * as peApi from '../pe.api';

const useRecentProjects = (workspaceId: number, pageNumber = 0, itemsPerPage = 4) =>
  useQuery(['recent-projects', workspaceId, pageNumber, itemsPerPage], () =>
    peApi.getRecentProjects({ itemsPerPage, pageNumber })
  );

export default useRecentProjects;
